<template>
  <div class="md-example-child md-example-child-detail-item md-example-child-detail-item-0 resultBankInfo">
    <md-field>
      <md-detail-item
        v-for="(item,index) in list"
        :key="item.title"
        :class="index === 0 && 'amount_text'"
        :title="item.title"
        :content="item.content"
      />
    </md-field>
  </div>
</template>

<script>
import { Field, DetailItem } from 'mand-mobile'
import { ACCOUNT_TYPE, TRANSACTION_STATUS, TRADE_TYPE } from '@/constants'
import { fenToYanAndFormat } from '@/utils/format-amount'
export default {
  name: 'ResultBankInfo',
  components: {
    [Field.name]: Field,
    [DetailItem.name]: DetailItem
  },
  props: {
    transferInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      fenToYanAndFormat
    }
  },
  computed: {
    list () {
      const { tradeType, payeeAccountType, status, subject } = this.transferInfo
      // tradeType 交易类型：1充值 2提现 3转账 4消费
      // payeeAccountType 0钱包 1银行账户 2银行卡号（本次没有这种情况）
      // status 0 等待交易 1银行受理中 2银行处理中 3 交易成功 4交易失败 5超时交易关闭
      // console.log(tradeType, payeeAccountType, status, 'payeeAccountType')
      const arr = [ // 默认会有的数据
        { title: 'Amount', content: 'Rp ' + fenToYanAndFormat(this.transferInfo.payerAmount) },
        { title: 'Transaction Type', content: subject }
      ]
      // 提现 银行处理中
      if (tradeType === TRADE_TYPE.WITHDRAW && status === TRANSACTION_STATUS.pending) {
        arr.push({ title: 'Est. Receive Time', content: this.transferInfo.estimatedReleaseTime })
      }

      // 转账到银行账户 成功、失败详情 或者 银行受理中 (产品要求remark要放在最后)
      if ((tradeType === TRADE_TYPE.TRANSFER && payeeAccountType === ACCOUNT_TYPE.BANK_ACCOUNT) || status === TRANSACTION_STATUS.pend) {
        arr.push({ title: 'Completed Time', content: this.transferInfo.finalTime })
        arr.push({ title: 'Receiver', content: this.transferInfo.payeeAccountName }) // 转账 失败 成功 或者 银行受理中
        arr.push({ title: 'Bank', content: this.transferInfo.issuingBank })
      }

      // 消费
      if (tradeType === TRADE_TYPE.CONSUME) {
        arr.push({ title: 'Created Time', content: this.transferInfo.tradeTime })
      }

      // 充值/转账到手机号和钱包账户的结果页面
      if (tradeType === TRADE_TYPE.RECHARGE || (tradeType === TRADE_TYPE.TRANSFER && (payeeAccountType === ACCOUNT_TYPE.WALLET_TYPE || payeeAccountType === ACCOUNT_TYPE.BANK_CARD))) {
        if (tradeType === TRADE_TYPE.RECHARGE) { // 充值
          arr.push({ title: 'Created Time', content: this.transferInfo.tradeTime })
        }
        if (tradeType === TRADE_TYPE.TRANSFER && status === TRANSACTION_STATUS.fail) { // 转账 失败
          arr.push({ title: 'Payee', content: this.transferInfo.payeeAccountName })
        }
        if (tradeType === TRADE_TYPE.TRANSFER && status === TRANSACTION_STATUS.success) { // 转账 成功
          arr.push({ title: 'Payee', content: this.transferInfo.payeeAccountName })
          arr.push({ title: 'Receive Time', content: this.transferInfo.finalTime })
        }
      }
      // 每个页面都有这个
      arr.push({ title: 'Order No.', content: this.transferInfo.tradeNo })

      // 转账到银行账户 成功、失败详情 或者 银行受理中 (产品要求remark要放在最后)
      if ((tradeType === TRADE_TYPE.TRANSFER && payeeAccountType === ACCOUNT_TYPE.BANK_ACCOUNT) || status === TRANSACTION_STATUS.pend) {
        arr.push({ title: 'Remark', content: this.transferInfo.note })
      }

      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
.resultBankInfo {
  width: 100%;
  background: #fff;
  border-radius: 32px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
}

.md-detail-item {
  margin-bottom: 24px;
}
/* stylelint-disable selector-pseudo-element-no-unknown */
::v-deep .amount_text > .md-detail-content {
  color: #242424;
  font-size: 36px;
  font-weight: 700;
}

.md-field {
  border-radius: 32px;
}
/* stylelint-enable */
</style>
